import { createRoute, Outlet } from "@tanstack/react-router"
import { HelpFeedbackPage } from "../+help.feedback.page"
import { HelpHowToPage } from "../+help.how-to.page"
import { HelpPage } from "../+help.page"
import { HelpRootPage } from "../+help.root.page"
import { appSearchSchema } from "./app-route.zod"
import { rootRoute } from "./root-route"

export const helpRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/help',
    component: () => <HelpPage><Outlet /></HelpPage>,
    validateSearch: appSearchSchema,
})

export const helpRootRoute = createRoute({
    getParentRoute: () => helpRoute,
    path: '/',
    component: () => <HelpRootPage />,
    validateSearch: appSearchSchema,
})
export const helpHowToRoute = createRoute({
    getParentRoute: () => helpRoute,
    path: '/how-to',
    component: () => <HelpHowToPage />,
    validateSearch: appSearchSchema,
})
export const helpFeedbackRoute = createRoute({
    getParentRoute: () => helpRoute,
    path: '/feedback',
    component: () => <HelpFeedbackPage />,
    validateSearch: appSearchSchema,
})